import Vue from 'vue'
import router from '../../../router'
import moment from 'moment'

export const promoBillings = {
    state: {
        status: 'idle',
        promoBillingsExportStatus: 'idle',
        promoBillings: null,
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        },
        sort: {
            by: 'promotionId',
            direction: 'desc'
        },
        filters: {
            usageDates: {
                type: 'dates',
                value: '',
                text: 'Data użycia',
                additionalText: 'Data użycia',
                lockFutureDays: [moment().format('YYYY-MM-DD')],
                lockRangeDaysNumber: 31
            },
            registerDates: {
                type: 'dates',
                value: '',
                text: 'Data rejestracji',
                additionalText: 'Data rejestracji',
                lockFutureDays: [moment().format('YYYY-MM-DD')],
                lockRangeDaysNumber: 31
            },
            producerId: {
                type: 'ui-virtual-list',
                moduleName: 'companies',
                value: null,
                searcher: false,
                getter: 'getCompaniesForFilters',
                label: 'Organizator'
            },
            promotionId: {
                type: 'ui-virtual-list',
                multi: true,
                value: [],
                moduleName: 'promotions',
                getter: 'getPromotionsForFilters',
                label: 'Promocja'
            },
            settlementWeek: {
                type: 'ui-virtual-list',
                searcher: false,
                value: null,
                getter: 'getPromoBillingsWeeks',
                label: 'Tydzień rozliczeniowy',
                additionalText: 'Tydzień rozliczeniowy'
            },
            settlementYear: {
                type: 'ui-virtual-list',
                searcher: false,
                value: null,
                getter: 'getPromoBillingsYears',
                label: 'Rok rozliczeniowy',
                additionalText: 'Rok rozliczeniowy'
            },
            usageStatus: {
                type: 'ui-virtual-list',
                searcher: false,
                value: null,
                getter: 'getPromoBillingsStatuses',
                label: 'Status'
            }
        }
    },
    mutations: {
        SET_PROMOBILLINGS_STATUS(state, payload) {
            state.status = payload
        },
        SET_PROMOBILLINGS(state, payload) {
            state.promoBillings = payload
        },
        SET_PROMOBILLINGS_TOTALPAGES(state, payload) {
            state.pagination.totalPages = payload
        },
        SET_PROMOBILLINGS_TOTALRECORDS(state, payload) {
            state.pagination.totalRecords = payload
        },
        SET_PROMOBILLINGS_CURRENT(state, payload) {
            state.pagination.page = payload
        },
        SET_PROMOBILLINGS_PERPAGE(state, payload) {
            state.pagination.perPage = payload
        },
        SET_PROMOBILLINGS_FILTER(state, payload) {
            Vue.set(
                state.filters[payload.filter],
                payload.key || 'value',
                payload.value
            )
        },
        RESET_PROMOBILLINGS_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        },
        SET_PROMOBILLINGS_SORT(state, payload) {
            state.sort = payload
        },
        SET_PROMOBILLINGS_EXPORT_STATUS(state, payload) {
            state.promoBillingsExportStatus = payload
        }
    },
    actions: {
        fetchPromoBillingReport({ commit, state, getters }) {
            const params = getters.getPromoBillingQueryParams
            params.paging = {
                ...params.paging,
                numberOfRows: null
            }
            if (!params.usageFrom || !params.usageTo) {
                params.usageFrom = Vue.moment()
                    .subtract(
                        state.filters.usageDates.lockRangeDaysNumber - 1,
                        'days'
                    )
                    .format('YYYY-MM-DD')
                params.usageTo = Vue.moment().format('YYYY-MM-DD')
            }
            if (!params.registerFrom || !params.registerTo) {
                params.registerFrom = Vue.moment()
                    .subtract(
                        state.filters.registerDates.lockRangeDaysNumber - 1,
                        'days'
                    )
                    .format('YYYY-MM-DD')
                params.registerTo = Vue.moment().format('YYYY-MM-DD')
            }
            commit('SET_PROMOBILLINGS_EXPORT_STATUS', 'loading')
            return this.$api
                .post('billingReportXlsx', params, {
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    const today = Vue.moment().format('YYYY-MM-DD')

                    const fileLink = document.createElement('a')
                    const blob = new Blob([response.data], {
                        type: '"application/octet-stream"'
                    })
                    fileLink.href = window.URL.createObjectURL(blob)
                    fileLink.download = `Raport rozliczeniowy-${today}.xlsx`
                    fileLink.click()
                    commit('SET_PROMOBILLINGS_EXPORT_STATUS', 'idle')
                })
                .catch(() => {
                    commit('SET_PROMOBILLINGS_EXPORT_STATUS', 'idle')
                })
        },
        promoBillingsFetch({ commit, state, getters }) {
            commit('SET_PROMOBILLINGS_STATUS', 'loading')

            if (router.currentRoute.query.page) {
                commit(
                    'SET_PROMOBILLINGS_CURRENT',
                    +router.currentRoute.query.page
                )
            }
            if (router.currentRoute.query.show) {
                commit(
                    'SET_PROMOBILLINGS_PERPAGE',
                    +router.currentRoute.query.show
                )
            }

            const params = getters.getPromoBillingQueryParams

            return this.$api
                .post('reports/billingData', params)
                .then(res => {
                    commit(
                        'SET_PROMOBILLINGS_TOTALRECORDS',
                        res.data.data.paging.count
                    )
                    commit(
                        'SET_PROMOBILLINGS_TOTALPAGES',
                        Math.ceil(
                            res.data.data.paging.count /
                                state.pagination.perPage
                        )
                    )
                    commit('SET_PROMOBILLINGS', res.data.data.billings)
                })
                .catch(err => {
                    if (!this.$api.isCancel(err)) {
                        commit('SET_PROMOBILLINGS_STATUS', 'idle')
                    }
                })
                .finally(() => {
                    commit('SET_PROMOBILLINGS_STATUS', 'idle')
                })
        },
        async promoBillingsFiltersFetch({ dispatch }) {
            await dispatch('devicesFetch')
        },
        setPromoRealizationsSort({ commit }, payload) {
            commit('SET_PROMOBILLINGS_SORT', payload)
        }
    },
    getters: {
        getPromoBillingQueryParams: (state, allGetters) => {
            const paging = {
                orderDirection: state.sort.direction.toUpperCase(),
                orderBy: state.sort.by,
                numberOfPage: state.pagination.page - 1,
                numberOfRows: state.pagination.perPage
            }
            const filters = JSON.parse(JSON.stringify(state.filters))
            let usageFrom = null
            let usageTo = null
            let registerFrom = null
            let registerTo = null

            if (filters.usageDates.value) {
                const dates = filters.usageDates.value.split(',')
                usageFrom = dates[0]
                usageTo = dates[1]
            }

            if (filters.registerDates.value) {
                const dates = filters.registerDates.value.split(',')
                registerFrom = dates[0]
                registerTo = dates[1]
            }
            return {
                paging,
                promotionIds: filters.promotionId.value.length
                    ? filters.promotionId.value
                    : null,
                producerId: filters.producerId.value,
                userId: allGetters.userId,
                usageFrom,
                usageTo,
                registerFrom,
                registerTo,
                usageStatus: filters.usageStatus.value,
                settlementWeek: filters.settlementWeek.value
                    ? +filters.settlementWeek.value
                    : null,
                settlementYear: filters.settlementYear.value
                    ? +filters.settlementYear.value
                    : null
            }
        },
        getPromoBillings: state => {
            return state.promoBillings
        },
        getPromoBillingsStatus: state => {
            return state.status
        },
        getPromoBillingsPagination: state => {
            return state.pagination
        },
        getPromoBillingsFilters: state => {
            return state.filters
        },
        getPromoBillingsSort: state => {
            return state.sort
        },
        getPromoBillingsWeeks: () => {
            const weeks = []
            for (let i = 1; i <= 52; i++) {
                weeks.push({
                    value: i,
                    label: i
                })
            }
            return weeks
        },
        getPromoBillingsYears: () => {
            const years = []
            for (let i = 0; i <= 2; i++) {
                years.push({
                    value: +moment()
                        .subtract(i, 'years')
                        .format('YYYY'),
                    label: +moment()
                        .subtract(i, 'years')
                        .format('YYYY')
                })
            }
            return years
        },
        getPromoBillingsStatuses: () => {
            const statuses = [
                {
                    value: 'C',
                    label: 'Prawidłowe'
                },
                {
                    value: 'I',
                    label: 'Nieprawidłowe'
                },
                {
                    value: 'B',
                    label: 'Zablokowane'
                }
            ]
            return statuses
        },
        getPromoBillingsResultsPhrase: state => {
            let phrase = 'Brak wyników'
            if (
                state.filters.settlementWeek.value &&
                !state.filters.settlementYear.value
            ) {
                phrase = 'Brak wyników dla bieżącego roku rozliczeniowego'
            }
            return phrase
        },
        getPromoBillingsExportStatus: state => {
            return state.promoBillingsExportStatus
        }
    }
}
